import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const taskList = {
    colorNumber: '#00529d',
    list: [
        'Актуализировать фирстиль и&nbsp;собрать брендбук;',
        'Провести аудит юзабилити сайта Фонда;',
        'Сделать редизайн и&nbsp;оптимизировать структуру сайта;',
        'Обновить систему управления сайтом;',
        'Разработать серию инфографиков и&nbsp;презентаций о&nbsp;ключевых направлениях работы Фонда;',
        'Сделать видеоролик для программы финансовой поддержки энергоэффективного капремонта.',
    ],
};

const Tasks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="zkhfoundation-tasks" bigPaddings={false}>
                <div className="zkhfoundation-tasks__wrapper">
                    <div className="zkhfoundation-tasks__info">
                        <CommonTitle>Задачи</CommonTitle>
                        <CommonUsualText className="zkhfoundation__text">
                            Чтобы представить Фонд в&nbsp;обновленном современном виде, перед нами
                            стояла комплексная задача из&nbsp;6&nbsp;этапов:
                        </CommonUsualText>
                    </div>
                    <CommonOlList className="zkhfoundation-tasks__list" CommonOlList={taskList} />
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
